import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const PoweredOnIcon = ({
  width = 20,
  height = 20,
  ...rest
}: {
  width?: number;
  height?: number;
  [x: string]: unknown;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M16.25 3.125C16.5952 3.125 16.875 3.40482 16.875 3.75V16.25C16.875 16.5952 16.5952 16.875 16.25 16.875H3.75C3.40482 16.875 3.125 16.5952 3.125 16.25V3.75C3.125 3.40482 3.40482 3.125 3.75 3.125H16.25ZM9.99707 6.25293C9.65196 6.25293 9.37218 6.53284 9.37207 6.87793V13.1279C9.37207 13.4731 9.65189 13.7529 9.99707 13.7529C10.3422 13.7529 10.6221 13.4731 10.6221 13.1279V6.87793C10.622 6.53288 10.3421 6.253 9.99707 6.25293Z"
        fill={token.colorSuccess}
      />
    </svg>
  );
};

export default PoweredOnIcon;
